export enum ModalSizeEnum {
  SMALL = "sm",
  MEDIUM = "md",
  LARGE = "lg",
  XLARGE = "xl",
  XXLARGE = "xl"//todo güncel versiyona kadar  xl olarak kalsın
}
